import Joi from "joi";
import {
  EVENT_NAME_MAX_LENGTH,
  EVENT_DESCRIPTION_MAX_LENGTH,
  EVENT_LOCATION_MAX_LENGTH,
  TICKET_NAME_MAX_LENGTH,
  TICKET_DESCRIPTION_MAX_LENGTH,
  T_PREFIX,
} from "./constants";

type TranslateFunction = (key: string) => string;

export const createEventSchema = (t: TranslateFunction) =>
  Joi.object({
    event_name: Joi.string()
      .trim()
      .min(1)
      .max(EVENT_NAME_MAX_LENGTH)
      .required()
      .label(t(`${T_PREFIX}.eventForm.nameLabel`))
      .messages({
        "string.empty": t(`${T_PREFIX}.schemaValidation.eventNameRequired`),
        "string.min": t(`${T_PREFIX}.schemaValidation.eventNameRequired`),
        "string.max": t(`${T_PREFIX}.schemaValidation.eventNameMaxLength`),
        "any.required": t(`${T_PREFIX}.schemaValidation.eventNameRequired`),
      }),
    event_description: Joi.string()
      .trim()
      .max(EVENT_DESCRIPTION_MAX_LENGTH)
      .allow("")
      .optional()
      .label(t(`${T_PREFIX}.eventForm.descriptionLabel`))
      .messages({
        "string.max": t(
          `${T_PREFIX}.schemaValidation.eventDescriptionMaxLength`
        ),
      }),
    location: Joi.string()
      .trim()
      .max(EVENT_LOCATION_MAX_LENGTH)
      .allow("")
      .optional()
      .label(t(`${T_PREFIX}.eventForm.locationLabel`))
      .messages({
        "string.max": t(`${T_PREFIX}.schemaValidation.eventLocationMaxLength`),
      }),
    active: Joi.boolean().default(true),
    event_image_url: Joi.string().allow("", null).optional(),
  });

export const createTicketSchema = (t: TranslateFunction) =>
  Joi.object({
    name: Joi.string()
      .trim()
      .min(1)
      .max(TICKET_NAME_MAX_LENGTH)
      .required()
      .label(t(`${T_PREFIX}.ticketForm.nameLabel`))
      .messages({
        "string.empty": t(`${T_PREFIX}.schemaValidation.ticketNameRequired`),
        "string.min": t(`${T_PREFIX}.schemaValidation.ticketNameRequired`),
        "string.max": t(`${T_PREFIX}.schemaValidation.ticketNameMaxLength`),
        "any.required": t(`${T_PREFIX}.schemaValidation.ticketNameRequired`),
      }),
    description: Joi.string()
      .trim()
      .max(TICKET_DESCRIPTION_MAX_LENGTH)
      .allow("")
      .optional()
      .messages({
        "string.max": t(
          `${T_PREFIX}.schemaValidation.ticketDescriptionMaxLength`
        ),
      }),
    price: Joi.number()
      .min(0)
      .required()
      .label(t(`${T_PREFIX}.ticketForm.priceLabel`))
      .messages({
        "number.base": t(`${T_PREFIX}.schemaValidation.priceRequired`),
        "number.min": t(`${T_PREFIX}.schemaValidation.priceMinValue`),
        "any.required": t(`${T_PREFIX}.schemaValidation.priceRequired`),
      }),
    currency: Joi.string().valid("USD", "EUR", "CHF").default("USD"),
    quantity_total: Joi.number()
      .min(1)
      .allow(null, "")
      .optional()
      .label(t(`${T_PREFIX}.ticketForm.quantityLabel`))
      .messages({
        "number.min": t(`${T_PREFIX}.schemaValidation.quantityMinValue`),
      }),
    min_per_order: Joi.number()
      .min(1)
      .default(1)
      .label(t(`${T_PREFIX}.ticketForm.minPerOrderLabel`))
      .messages({
        "number.min": t(`${T_PREFIX}.schemaValidation.minPerOrderMinValue`),
      }),
    max_per_order: Joi.number()
      .min(1)
      .max(10)
      .default(2)
      .label(t(`${T_PREFIX}.ticketForm.maxPerOrderLabel`))
      .messages({
        "number.min": t(`${T_PREFIX}.schemaValidation.maxPerOrderMinValue`),
        "number.max": t(`${T_PREFIX}.schemaValidation.maxPerOrderMaxValue`),
      }),
    show_remaining_tickets: Joi.boolean().default(true),
    sale_start_date: Joi.string().allow("", null).optional(),
    sale_end_date: Joi.string().allow("", null).optional(),
    group_identification: Joi.string().allow("", null).optional(),
  });
